import { Injectable } from '@angular/core';
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';  
import { DashboardSummary } from '../models/dashboardsummary'; 
@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  apiEndpoint: string = "";
  apiUniqueId: string = 'dashboard/id/D32A6CC9-353B-4E23-90FB-3C410CD6FD7E/';
  constructor(
    private httpService: HttpWrapperService,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }
  getSummaryCounts(filter: string, pagesize: number, pagenumber: number): Observable<Array<DashboardSummary>> {
    return this.httpService.get(this.apiEndpoint + 'getSummaryCounts?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }  
}
